// @ts-nocheck

"use client"

import Link from "next/link"
import Image from "next/image"
import React from "react"
import { API_URI } from "@/config/API_URI"
import "./styles.scss"

const Item = ({ title, link, photo, type }) => {
    return (
        <Link href={link || "/"} className={`relative max-w-[440px] w-full h-[294px] flex justify-center items-end border-2 border-white`}>
            <div className={`relative max-w-[440px] w-full h-[290px] flex justify-center items-end py-5 overflow-hidden`}>
                <Image
                    src={photo || "/images/"}
                    alt={title || " "}
                    layout="fill"
                    objectFit="cover"
                    loading="lazy"
                    lang="pl"
                    quality={100}
                    className="relative z-[1] hover:scale-[1.15] duration-500 ease-in-out"
                />
                <div className="absolute z-[10] max-w-[411px] w-full bg-[#2A3026]/[.64] rounded-[39px] h-[70px] flex flex-col gap-0 justify-center items-center">
                    <h5 className="text-[#EBD29F] text-[36px] leading-[36px] font-['Didot'] text-center uppercase w-full">
                        {title || ""}
                    </h5>
                    <h6 className="text-[#EBD29F] text-[14px] leading-[14px] font-medium font-['Comfortaa'] text-center w-full flex flex-row gap-1 justify-center items-center">
                        see more
                        <Image
                            src="/images/beluxe/arrow-right.svg"
                            alt="Arrow right"
                            layout="intrinsic"
                            lang="pl"
                            width={13}
                            height={10}
                            quality={100}
                        />
                    </h6>
                </div>
            </div>
            <div className={`absolute z-[10] top-0 w-[100px] h-[53px] ${type === "dark" ? "bg-[#2A3026]" : "bg-[#E5E3DE]"} border-2 border-white border-t-0 mt-[-2px] flex justify-center items-center rounded-bl-full rounded-br-full`}>
                <div className="relative w-[40px] h-[36px]">
                    <Image
                        src="/images/beluxe/beluxe-black__logo.svg"
                        alt="BeLuxe Black Logo"
                        layout="fill"
                        objectFit="contain"
                        lang="pl"
                        quality={100}
                        className={`${type === "dark" ? "invert" : ""}`}
                    />
                </div>
            </div>
        </Link>
    )
}

const GuidesElements = ({ type, title, subtitle, articles, content }) => {
    const handleBgColor = (type) => {
        switch (type) {
            case "dark":
                return "!bg-[#2A3026]"
        }
    }
    const handleTextColor = (type) => {
        switch (type) {
            case "dark":
                return "!text-white"
        }
    }
    const handleHeadlineColor = (type) => {
        switch (type) {
            case "dark":
                return "!text-[#EBD29F]"
        }
    }
    return (
        <section className={`guides-elements__wrapper ${handleBgColor(type)}`}>
            <div className="guides-elements__container">
                <div className="guides-elements__header">
                    <h5 className={`text-[18px] font-bold font-['Comfortaa'] tracking-[0.25rem] leading-[20px] text-[#212121] ${handleTextColor(type)} text-center uppercase w-full`}>
                        {subtitle || ""}
                    </h5>
                    <h4 className={`text-[36px] font-bold font-['Didot'] tracking-[0rem] leading-[42px] text-[#212121] ${handleHeadlineColor(type)} text-center uppercase w-full`}>
                        {title || ""}
                    </h4>
                    {type === "dark" ?
                        <p className="text-[16px] text-white font-medium text-left leading-[22px] tracking-0 font-['Comfortaa'] pt-3 max-w-[1340px] w-full">
                            Embark on your real estate journey with our all-inclusive resources covering buying, selling, and area guides. Uncover invaluable insights, expert advice, and detailed neighborhood information tailored to enhance your property experience. Whether its finding your perfect home, selling a property, or exploring local areas, our guides provide the essential knowledge for informed decisions, empowering your real estate endeavors every step of the way.
                        </p>
                    : null}
                </div>
                <div className="guides-elements__list">
                    {articles && articles.length > 0 && articles.map((guide, index) =>
                        <Item
                            key={index}
                            title={guide.title}
                            link={guide.link}
                            photo={`${API_URI}${guide.photo}`}
                            type={type}
                        />
                    )}
                </div>
            </div>
        </section>
    )
}

export default GuidesElements